import React, { useState } from "react";
import "./Tooltip.css";

const Tooltip = ({ children, content, placement = "top", className = "" }) => {
  const [visible, setVisible] = useState(false);
  const tooltipClassName = [
    "custom-tooltip",
    `custom-tooltip-${placement}`,
    !visible && "custom-tooltip-hidden",
    className,
  ].filter(Boolean).join(" ");

  return (
    <span
      className={tooltipClassName}
      data-tooltip={content}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
      onClick={() => setVisible(false)}
      onContextMenu={() => setVisible(false)}
    >
      {children}
    </span>
  );
};

export default Tooltip;
